<template>
  <div class="order-pages">
    <div class="p16 align-items">
      <div>档案管理</div>
      <el-button type="primary" @click="gotoRepair">新建档案</el-button>
    </div>
    <div class="page-head">
      <div class="mains-content br10">
        <div class="member-content-box br10">
          <div class="member-header">
            <div class="flex-row wraps pb16">
              <div class="">
                <div class="align-item pt16">
                  <div class="select-title">顾客搜索：</div>
                  <member @handleChange="memberChange" class="mr10"></member>
                  <!-- <el-input v-model="query.keyword" placeholder="请输入手机号/姓名" clearable maxlength="11" class="w200 mr10"></el-input> -->
                  <div class="select-title">档案状态：</div>
                  <el-select v-model="query.repairStatus" class="select">
                    <el-option label="全部状态" value></el-option>
                    <el-option label="建档" value="build"></el-option>
                    <el-option label="进行中" value="handle"></el-option>
                    <el-option label="期限内完成" value="intimeFinish"></el-option>
                    <el-option label="逾期完成" value="outtimeFinish"></el-option>
                    <el-option label="逾期未完成" value="outtimeUnfinish"></el-option>
                    <el-option label="已完成" value="finish"></el-option>
                    <el-option label="已退款" value="refund"></el-option>
                    <el-option label="已作废" value="invalid"></el-option>
                  </el-select>
                  <div class="select-title">档案类型：</div>
                  <el-select v-model="query.categoryId" class="select">
                    <el-option label="全部类型" value></el-option>
                    <el-option label="甲沟炎" value="a"></el-option>
                    <el-option label="灰指甲" value="b"></el-option>
                    <el-option label="血胞刺" value="c"></el-option>
                    <el-option label="肉刺" value="d"></el-option>
                    <el-option label="脚气（癣）" value="e"></el-option>
                    <el-option label="通用档案" value="f"></el-option>
                  </el-select>
                  <div class="select-title">建档店员：</div>
                  <el-select v-model="query.staffId" class="select">
                    <el-option label="全部店员" value></el-option>
                    <el-option
                        v-for="item in staffList"
                        :key="item.id"
                        :label="item.staffName"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div class="align-item pt16">
                  <div class="select-title">建档时间：</div>
                  <v-notDate :beginTime="query.beginTime" :endTime="query.endTime" @time="changeDate"></v-notDate>
                  <el-button type="primary" class="ml10" @click="doData">搜索</el-button>
                </div>
              </div>
              
            </div>
            <!-- <div class="selece_bg pb16 btn_style"><el-button @click="reset">重置</el-button></div> -->
          </div>
        </div>
        <div class="plr16">
          <el-table :data="list" :max-height="height - 342" header-cell-class-name="table_header_bgcolor">
            <el-table-column
              :prop="index"
              :align="item.align"
              :label="item.label"
              :width="item.width"
              :min-width="item.minWidth"
              :show-overflow-tooltip="false"
              v-for="(item,index) in columns"
              :key="index"
            >
              <template slot-scope="scope">
                <div v-if="index == 'recordTime'">{{formatDay(scope.row.recordTime)}}</div>
                <div v-else-if="index == 'categoryName'">
                    <span v-if="scope.row.payPeriodFlag">{{scope.row.categoryName}}<span class="jishi">(分期)</span></span>
                  <span v-else>{{scope.row.categoryName}}</span>            
                </div>
                <div v-else-if="index == 'nextRepairTime'">{{scope.row.repairStatus == 'handle'  || scope.row.repairStatus == "build" ? formatDay(scope.row.nextRepairTime) : ""}}</div>
                <div v-else-if="index == 'validEndTime'">
                  {{scope.row.validDay==-1?'永久有效':scope.row.repairStatus == 'finish' ? formatDay(scope.row.oxLtime) : scope.row.repairStatus == 'build' || scope.row.repairStatus == "refund" ? "" : formatDay(scope.row.validEndTime)}}</div>
                <div v-else>{{Boolean(item.formatDay)?formatDay(scope.row[index]):scope.row[index]}}</div>
              </template> 
            </el-table-column>
            <el-table-column prop="amt" label="操作" align="center" width="80" fixed="right">
              <template slot-scope="scope">
                <el-link type="primary" @click="handleDetail(scope.row)">详情</el-link>
              </template>
            </el-table-column>
          </el-table>
          <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
        </div>
      </div>
    </div>
    <handle ref="handleForm" @change="handleSave"></handle>
    <handle-edit ref="handleEditForm" @change="editChange"></handle-edit>
    <repair-check-in ref="checkInForm" @change="handleSave"></repair-check-in>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import member from "../../components/noMemberList.vue";
import config from "./config/columns";
import handle from "./handle";
import handleEdit from "./handle-edit";
import repairCheckIn from "./repairCheckIn";
export default {
  mixins: [minxin],
  components: { member, handle, handleEdit, repairCheckIn },
  data() {
    return {
      columns: config.columns,
      totalAmount: 0,
      form: {
        memberId: "",
        
      },
      url: this.$url.repairDocument.list,
      list: [],
      staffList: [],
      query: {
        keyword: this.$route.query.mobile ? this.$route.query.mobile : "",
        categoryId: "",
        memberId: "",
        beginTime: "",
        endTime: "",
        repairStatus: "",
        staffId: ""
      },
      height: this.$store.getters.MainHeight
    };
  },
// 
  created() {
    this.query.categoryId = this.$route.query.categoryId || "";
    if (sessionStorage.getItem("repairStatus")) {
      this.query.repairStatus = sessionStorage.getItem("repairStatus");
      sessionStorage.removeItem("repairStatus")
    }
    
    this.getStaff();
    this.totalCounts();
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("payMobile"))) {
      let arr = JSON.parse(localStorage.getItem("payMobile"));
      if (arr.path == this.$route.path) {
        let rows = JSON.parse(localStorage.getItem("repairEditRows"));
        this.$refs["checkInForm"].$emit("set", {
          id: rows.id,
          repairStatus: rows.repairStatus
        });
      }
    }
  },
  watch: {
      list (o) {
          let shopId = localStorage.getItem("shopIds")
        o.map(item => {
            
            if (shopId == item.shopId) {
                return
            } else {
                item.amount = "****";
                item.realPayAmount = "****";
            }
        })
        
      }
  },
  methods: {
    editChange() {
  
    },
    reset () {
      this.query = {
        keyword: this.$route.query.mobile ? this.$route.query.mobile : "",
        categoryId: "",
        memberId: "",
        beginTime: "",
        endTime: "",
        repairStatus: "",
        staffId: ""
      },
      this.query.start = 1;
      this.totalCounts();
    },
    changeDate(value) {
      console.log(value);
      this.query.start = 1;
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
    },
    memberChange(value) {
      if (value) {
        this.query.keyword = value;
      } else {
        this.query.keyword = "";
      }
      this.totalCounts();
    },
    getStaff () {
      // 获取店员
      this.$api.get(this.$url.companyStaff.listByStaffStatus, {staffStatus: 'enable'}).then(res => {
          this.staffList = res;
      })
    },
    gotoRepair() {
      this.$router.push("/collectMoney/paperRepair");
    },
    handleDetail(row, index) {
      if (row.repairStatus == "handle") {
        this.$refs["handleForm"].$emit("set", {
          id: row.id,
          repairStatus: row.repairStatus
        });
      } else {
        this.$refs["checkInForm"].$emit("set", {
          id: row.id,
          repairStatus: row.repairStatus
        });
        localStorage.setItem("repairEditRows", JSON.stringify(row));
      }
    },
    handleSave(org) {
      if (org) {
        this.totalCounts();
      }
    },
    totalCounts () {
      this.$api.post(this.$url.repairDocument.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
.member-content-box {
  background: #fff;
}
.btn_style {
  padding-left: 96px;
}
  .member-header {
    padding: 0 16px;
    .setDate {
      margin-right: 15px;
    }
    .top-label {
      width: 90px;
    }
    /deep/ .el-select {
      width: 150px;
      margin-right: 15px;
      /deep/ .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }
    .input-with-select {
      width: 150px;
      height: 32px;
      margin-right: 15px;
      /deep/ .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
      /deep/ .el-input__clear {
        font-size: 22px;
        line-height: 32px;
      }
      /deep/ .el-input__prefix {
        color: @blue;
        font-size: 24px;
        margin-right: 10px;
        .el-input__icon {
          line-height: 32px;
        }
      }
    }
  }

.page-head {
  height: 100%;
}
.mains-bottom {
  width: calc(100% - 30px);
  position: absolute;
  background-color: #fff;
  height: 62px;
  margin-top: 10px;
  padding: 0 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  bottom: 15px;
  box-sizing: border-box;
  .last-btn {
    margin-left: 22px;
  }
}
.mains-content {
  height: calc(100% - 72px);
  background: #fff;
}
.isMember {
  width: 220px;
}
</style>